import React, { useEffect, useState } from 'react';
import { App } from '../src';
import resources from '../src/assets/locale';
import { ShellRootProvider } from '../src/contexts/ShellRoot';
import {
  ShellRootComponentProps,
  TranslatorFunctionType
} from '../src/types/shell';
import projectNames from './configs/projectNames';
import { Providers } from 'src/contexts';

export default function Root({
  properties,
  onMount,
  onUnmount,
  localizationResources,
  ...props
}: ShellRootComponentProps): React.ReactElement | null {
  const [t, setT] = useState<TranslatorFunctionType>();
  const interfaces = window.Shell;

  useEffect(() => {
    if (typeof onMount === 'function') onMount?.();

    return () => {
      if (typeof onUnmount === 'function') onUnmount?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Create a translator function by providing the resource files
  useEffect(() => {
    interfaces.v1.localization
      .createTranslatorFunction(resources || localizationResources)
      .then((v) => setT(() => v));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interfaces.v1]);

  // Wait for the translator function creation to show the content
  if (!t) return null;

  return (
    <section
      className={`${projectNames.sanitizedPackageName}`}
      id={projectNames.packageName}
      style={{ minHeight: 'inherit' }}
    >
      <ShellRootProvider {...{ interfaces, t, properties, ...props }}>
        <Providers>
          <App />
        </Providers>
      </ShellRootProvider>
    </section>
  );
}
